// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopPortableBankCardControllerActivateBankCardData } from './EshopPortableBankCardControllerActivateBankCardData.gen';
import type { EshopPortableBankCardControllerActivateBankCardErrors } from './EshopPortableBankCardControllerActivateBankCardErrors.gen';
import type { EshopPortableBankCardControllerActivateBankCardResponses } from './EshopPortableBankCardControllerActivateBankCardResponses.gen';
import type { EshopPortableBankCardControllerBlockBankCardData } from './EshopPortableBankCardControllerBlockBankCardData.gen';
import type { EshopPortableBankCardControllerBlockBankCardErrors } from './EshopPortableBankCardControllerBlockBankCardErrors.gen';
import type { EshopPortableBankCardControllerBlockBankCardResponses } from './EshopPortableBankCardControllerBlockBankCardResponses.gen';
import type { Options } from './Options.gen';

export class EshopPortableBankCardController {
    /**
     * Block active bank card.
     */
    public static blockBankCard<ThrowOnError extends boolean = false>(options: Options<EshopPortableBankCardControllerBlockBankCardData, ThrowOnError>) {
        return (options.client ?? client).put<EshopPortableBankCardControllerBlockBankCardResponses, EshopPortableBankCardControllerBlockBankCardErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/portable-bank-cards/{id}/block',
            ...options
        });
    }
    
    /**
     * Activate blocked bank card.
     */
    public static activateBankCard<ThrowOnError extends boolean = false>(options: Options<EshopPortableBankCardControllerActivateBankCardData, ThrowOnError>) {
        return (options.client ?? client).put<EshopPortableBankCardControllerActivateBankCardResponses, EshopPortableBankCardControllerActivateBankCardErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/portable-bank-cards/{id}/activate',
            ...options
        });
    }
}
